exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media screen and (min-width: 1100px){\n.card-header .btn-sm .plus[data-v-7b43009a]{display:none\n}\n}\n@media screen and (max-width: 1100px){\n.card-header .btn-sm[data-v-7b43009a]{line-height:16px\n}\n.card-header .btn-sm .button-text[data-v-7b43009a]{display:none\n}\n.card-header .btn-sm .plus[data-v-7b43009a]{display:inline\n}\n}\n.switch.switch-text.switch-lg.wide-toggle[data-v-7b43009a]{width:180px\n}\n.switch.switch-text.switch-lg.wide-toggle .switch-input:checked~.switch-handle[data-v-7b43009a]{left:154px\n}\n.switch.switch-text.switch-lg.wide-toggle .switch-label[data-v-7b43009a]::after,.switch.switch-text.switch-lg.wide-toggle .switch-label[data-v-7b43009a]::before{width:156px\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-7b43009a","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/t1/Admin/User.vue
// module id = 1819
// module chunks = 0